/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { ORDER_TRACKING_ID_PARAM, ORDER_TRACKING_PATH } from '../configuration/order-tracking';
import { HTTPS } from '../configuration/protocol';

/**
 * Builds the absolute url of the anonymous order tracking page for a single delivery.
 * @param canonicalDomain - Domain of the environment the link points at, e.g. loop-dev.lanxess.com, loop-uat.lanxess.com or loop.lanxess.com.
 * @param trackingNumber - Tracking number of the delivery, as delivered by GetOrderDetail.
 * @returns Shareable url to the anonymous order tracking page.
 */
export const getOrderTrackingPageUrl = (canonicalDomain: string, trackingNumber: string): string =>
    `${HTTPS}${canonicalDomain}${ORDER_TRACKING_PATH}?${ORDER_TRACKING_ID_PARAM}=${encodeURIComponent(trackingNumber)}`;
